import { useEffect, useRef, useState, useCallback } from "react";
import { useAuth } from "./AuthProvider";
import userService from "../../../services/userService";
import { forceLogout } from "../../../services/oidc/authConfig";

export function useOidcUser() {
  const { isAuthenticated, isLoading, error } = useAuth();
  const [user, setUser] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);
  const hasLoadedRef = useRef(false);

  const loadUser = useCallback(async () => {
    setLoadingUser(true);
    try {
      const result = await userService.auth();
      setUser(result);
    } catch (e) {
      console.error("User profile loading failed:", e);
      if (e?.status === 401 || e?.response?.status === 401) {
        forceLogout("session_invalid");
        return;
      }
      setUser(null);
    } finally {
      setLoadingUser(false);
    }
  }, []);

  useEffect(() => {
    const persistedAuth = localStorage.getItem("isAuthenticated") === "true";
    if (!isAuthenticated && !persistedAuth) {
      setUser(null);
      hasLoadedRef.current = false;
      sessionStorage.setItem(
        "post_login_redirect",
        window.location.pathname + window.location.search,
      );
      window.location.href = "/login"; // soft logout redirect
    }

    if (!hasLoadedRef.current) {
      hasLoadedRef.current = true;
      loadUser();
    }
  }, [isAuthenticated, isLoading, loadUser]);

  return {
    user,
    setUser,
    isAuthenticated,
    isLoading: isLoading || loadingUser,
    error,
  };
}
